import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-task-getSprints',
  templateUrl: './task-getSprints.component.html'
})
export class TaskGetSprintsComponent {
  taskCarrierId:any;
  taskResourceId:any;
  sprints:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  search() {
    var params:HttpParams = new HttpParams()
      .set("taskCarrierId", this.taskCarrierId)
      .set("taskResourceId", this.taskResourceId)
    ;

    this.http.get(`${this.env.e.url}/task/omni/sprints`, {params:params}).subscribe(
      data => {
        this.sprints = data;
      }
    );
  }
}
